<template>
    <div>
        <v-card class="my-shadow">
            <v-card-title class="v-card-title-text">{{$t('Product pricing')}}</v-card-title>
            <v-card-text>
                <div class="border mt-1 mb-5 pa-4" v-if="$product.product.smake">
                    <div class="row"  v-if="$store.getters.user.website_role.name === 'admin'">
                        <div class="col-md-3">
                            <v-text-field prefix="$" outlined class="no-validation" type="number" :min="0" label="Custom fee" v-model="$product.product.ssm_fees"></v-text-field>
                        </div>
                        <div v-if="$product.product.id" class="col-md-3 d-flex align-center">
                            <v-btn color="secondary" @click="updateFee()" class="white--text small-btns">Update custom fee</v-btn>
                        </div>
                    </div>
                    <div class="row mt-4" v-if="$store.getters.user && $store.getters.user.website_role.name === 'admin' && $product.product.is_customizable">
                        <div class="col-md-4">
                            <v-text-field type="number" :min="0" step="0.01" :rules="[validationRules.required]" v-model="$product.product.first_custom_fee" outlined label="Initials print cost"></v-text-field>
                        </div>
                        <div class="col-md-4">
                            <v-text-field type="number" :min="0" step="0.01" :rules="[validationRules.required]" v-model="$product.product.second_custom_fee"  outlined label="Map print cost"></v-text-field>
                        </div>

                        <div class="col-md-4">
                            <v-text-field type="number" :min="0" step="0.01" :rules="[validationRules.required]" v-model="$product.product.third_custom_fee"  outlined label="Hidden message cost"></v-text-field>
                        </div>
                    </div>
                    <div class="row mt-0" v-if="$product.product.is_customizable">
                        <div class="col-md-4">
                            <v-text-field @input="changePriceMarginValue" @change="changePriceMarginValue" type="number" :min="0" step="0.01" :rules="[validationRules.required]" v-model="$product.product.first_margin_fee" outlined label="Initials print margin"></v-text-field>
                        </div>
                        <div class="col-md-4">
                            <v-text-field type="number" :min="0" step="0.01" :rules="[validationRules.required]" v-model="$product.product.second_margin_fee"  outlined label="Map print margin"></v-text-field>
                        </div>
                        <div class="col-md-4">
                            <v-text-field type="number" :min="0" step="0.01" :rules="[validationRules.required]" v-model="$product.product.third_margin_fee"  outlined label="Hidden message margin"></v-text-field>
                        </div>
                    </div>
                    <p v-if="$store.getters.user.production_margin == 1" class="mb-0">{{$t('Visual impression price')}}: ${{$product.smallestSizePrice | currency()}}</p>
                    <p v-if="$product.product.ssm_fees && $product.product.ssm_fees>0 && $store.getters.user.production_margin == 1" class="mb-0">{{$t('Custom fee')}}:&nbsp;${{$product.product.ssm_fees | currency()}}</p>
                    <p v-if="!$product.product.smake.print_price_second && $store.getters.user.production_margin == 1 && !$product.product.is_customizable" class="mb-0">Product price with one decoration: <span style="font-weight: 600;">${{$product.product.smake.print_price | currency()}}</span></p>
                    <p v-else-if="$store.getters.user.production_margin == 1 && !$product.product.is_customizable" class="mb-0">Product price with one decoration: <span style="font-weight: 600;">${{$product.product.smake.print_price | currency()}}</span> Price with two decorations: <span style="font-weight: 600">${{ ($product.product.smake.print_price+$product.product.smake.print_price_second) | currency()}}</span></p>
                    <p v-else-if="$store.getters.user.production_margin != 1 && !$product.product.is_customizable" class="mb-0">Product price with one decoration: <span style="font-weight: 600;">${{$product.product.smake.print_price*$store.getters.user.production_margin | currency()}}</span> Price with two decorations: <span style="font-weight: 600">${{ ($product.product.smake.print_price+$product.product.smake.print_price_second)*$store.getters.user.production_margin | currency()}}</span></p>
                    <p v-else-if="$product.product.is_customizable">Map decoration price: <span style="font-weight: 600;">${{$product.product.first_custom_fee | currency()}}</span></p>
                    <p class="mb-0" v-if="!$product.product.is_customizable">Total decorations for this product: <span style="font-weight: 600;">{{$product.totalPrintAreas}}</span></p>
<!--                    <p v-if="$store.getters.user.production_margin != 1">{{$t('Visual impression price')}}: ${{getMinimumProductPrice() | currency()}}</p>-->
                    <v-divider class="my-3"></v-divider>
                    <div class="row">
                        <div class="col-md-5 pb-0">
                            <v-text-field prefix="$" class="mb-0" outlined autocomplete="off" step="0.01" :rules="[validationRules.required, validationRules.minProductPrice(this.currProductPrice,getMinimumProductPrice())]" @change="changeMarginValue" @input="changeMarginValue"  :label="$t('Enter product price')" type="number"  v-model="currProductPrice"></v-text-field>
                        </div>
                        <div class="col-md-2 pb-0">

                        </div>
                        <div class="col-md-5 pb-0">
                            <v-text-field prefix="$" class="mb-0" outlined @change="changePriceValue" @input="changePriceValue" :rules="[validationRules.required]" :label="$t('Your product margin')" min="0.00" type="number" step="0.01" v-model="currProductMargin"></v-text-field>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    import {updateCustomFee} from "../../api/products";
    export default {
        data:() => {
            return{
                currProductMargin: null,
                currProductPrice: null
            }
        },
        mounted(){
            if(this.$store.getters.activeWebsite) this.$set(this.$product, 'user', this.$store.getters.activeWebsite.user);

            let interval = setInterval(()=>{
                if(this.$product.productPriceDelta){
                    this.$set(this, 'currProductMargin',  this.$product.product.price);
                    this.$set(this, 'currProductPrice',  this.$product.productPriceDelta);
                    clearInterval(interval);
                }
            },250)

        },
        methods:{
            changeMarginValue(ev){
                this.currProductPrice = ev;
                let totalViPrice;
                let variantPrice = this.$product.product.smake.price;
                let sizeOfVariants = this.$product.product.variants.length;
                let sizeOfCreatedVariants = this.$product.product.smake.data.variants.length;
                if(this.$product.product.variants && sizeOfVariants > 0){
                    for(let i=0; i<sizeOfCreatedVariants;i++){
                        if((this.$product.product.smake.data.variants[i].attributes[1].value == 'XS' || this.$product.product.smake.data.variants[i].attributes[1].value == 'S') && this.$product.product.smake.data.variants[i].total){
                            for(let j=0;j<sizeOfVariants;j++){
                                if(this.$product.product.variants[j].attributes[0].value == this.$product.product.smake.data.variants[i].attributes[0].value){
                                    variantPrice = this.$product.product.smake.data.variants[i].total;
                                    i = sizeOfCreatedVariants;
                                    j = sizeOfVariants;
                                }
                            }
                        }
                    }
                } else {
                    let sizeOfVariants = this.$product.product.smake.data.variants.length;
                    for(let i=0; i<sizeOfVariants;i++){
                        if((this.$product.product.smake.data.variants[i].attributes[1].value == 'XS' || this.$product.product.smake.data.variants[i].attributes[1].value == 'S') && this.$product.product.smake.data.variants[i].total){
                            variantPrice = this.$product.product.smake.data.variants[i].total;
                            i = sizeOfVariants;
                        }
                    }
                }
                if(this.$product.product.is_customizable && this.$product.product.is_customizable == 1){
                    totalViPrice = variantPrice + parseFloat(this.$product.product.first_custom_fee) + parseFloat(this.$product.product.first_margin_fee);
                } else {
                    if(this.$product.totalPrintAreas == 1  || !this.$product.product.smake.print_price_second){
                        totalViPrice = variantPrice + (this.$product.product.smake.print_price * this.$product.totalPrintAreas);
                    } else {
                        totalViPrice = variantPrice + (this.$product.product.smake.print_price + this.$product.product.smake.print_price_second);
                    }
                }

                if(this.$product.product.ssm_fees) totalViPrice+=parseFloat(this.$product.product.ssm_fees);
                if(this.$store.getters.activeWebsite && this.$store.getters.activeWebsite.user) totalViPrice=totalViPrice*this.$store.getters.activeWebsite.user.production_margin;

                const formatter = new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
                const finalPrice = (parseFloat(formatter.format(ev)) - parseFloat(formatter.format(totalViPrice))).toFixed(2);
                this.$product.product.price = finalPrice;
                this.currProductMargin = finalPrice;
            },
            changePriceValue(ev){
                this.currProductMargin = ev;
                this.$product.product.price = ev;
                let totalViPrice;
                let variantPrice = this.$product.product.smake.price;
                let sizeOfVariants = this.$product.product.variants.length;
                let sizeOfCreatedVariants = this.$product.product.smake.data.variants.length;
                if(this.$product.product.variants && sizeOfVariants > 0){
                    for(let i=0; i<sizeOfCreatedVariants;i++){
                        if((this.$product.product.smake.data.variants[i].attributes[1].value == 'XS' || this.$product.product.smake.data.variants[i].attributes[1].value == 'S') && this.$product.product.smake.data.variants[i].total){
                            for(let j=0;j<sizeOfVariants;j++){
                                if(this.$product.product.variants[j].attributes[0].value == this.$product.product.smake.data.variants[i].attributes[0].value){
                                    variantPrice = this.$product.product.smake.data.variants[i].total;
                                    i = sizeOfCreatedVariants;
                                    j = sizeOfVariants;
                                }
                            }
                        }
                    }
                } else {
                    let sizeOfVariants = this.$product.product.smake.data.variants.length;
                    for(let i=0; i<sizeOfVariants;i++){
                        if((this.$product.product.smake.data.variants[i].attributes[1].value == 'XS' || this.$product.product.smake.data.variants[i].attributes[1].value == 'S') && this.$product.product.smake.data.variants[i].total){
                            variantPrice = this.$product.product.smake.data.variants[i].total;
                            i = sizeOfVariants;
                        }
                    }
                }
                if(this.$product.product.is_customizable && this.$product.product.is_customizable == 1){
                    totalViPrice = variantPrice + parseFloat(this.$product.product.first_custom_fee);
                } else {
                    if(this.$product.totalPrintAreas == 1  || !this.$product.product.smake.print_price_second){
                        totalViPrice = variantPrice + (this.$product.product.smake.print_price * this.$product.totalPrintAreas);
                    } else {
                        totalViPrice = variantPrice + (this.$product.product.smake.print_price + this.$product.product.smake.print_price_second);
                    }
                }
                if(this.$product.product.ssm_fees) totalViPrice += parseFloat(this.$product.product.ssm_fees);
                if(this.$store.getters.activeWebsite && this.$store.getters.activeWebsite.user) totalViPrice=totalViPrice*this.$store.getters.activeWebsite.user.production_margin;
                if(this.$product.product.is_customizable && this.$product.product.is_customizable == 1) totalViPrice+= parseFloat(this.$product.product.first_margin_fee);
                const formatter = new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
                const finalPrice = (parseFloat(formatter.format(ev))+parseFloat(formatter.format(totalViPrice))).toFixed(2);
                this.currProductPrice = finalPrice;
            },
            changePriceMarginValue(){
                let totalViPrice;
                let variantPrice = this.$product.product.smake.price;
                let sizeOfVariants = this.$product.product.variants.length;
                let sizeOfCreatedVariants = this.$product.product.smake.data.variants.length;
                if(this.$product.product.variants && sizeOfVariants > 0){
                    for(let i=0; i<sizeOfCreatedVariants;i++){
                        if((this.$product.product.smake.data.variants[i].attributes[1].value == 'XS' || this.$product.product.smake.data.variants[i].attributes[1].value == 'S') && this.$product.product.smake.data.variants[i].total){
                            for(let j=0;j<sizeOfVariants;j++){
                                if(this.$product.product.variants[j].attributes[0].value == this.$product.product.smake.data.variants[i].attributes[0].value){
                                    variantPrice = this.$product.product.smake.data.variants[i].total;
                                    i = sizeOfCreatedVariants;
                                    j = sizeOfVariants;
                                }
                            }
                        }
                    }
                } else {
                    let sizeOfVariants = this.$product.product.smake.data.variants.length;
                    for(let i=0; i<sizeOfVariants;i++){
                        if((this.$product.product.smake.data.variants[i].attributes[1].value == 'XS' || this.$product.product.smake.data.variants[i].attributes[1].value == 'S') && this.$product.product.smake.data.variants[i].total){
                            variantPrice = this.$product.product.smake.data.variants[i].total;
                            i = sizeOfVariants;
                        }
                    }
                }
                if(this.$product.product.is_customizable && this.$product.product.is_customizable == 1){
                    totalViPrice = variantPrice + parseFloat(this.$product.product.first_custom_fee);
                } else {
                    if(this.$product.totalPrintAreas == 1  || !this.$product.product.smake.print_price_second){
                        totalViPrice = variantPrice + (this.$product.product.smake.print_price * this.$product.totalPrintAreas);
                    } else {
                        totalViPrice = variantPrice + (this.$product.product.smake.print_price + this.$product.product.smake.print_price_second);
                    }
                }
                if(this.$product.product.ssm_fees) totalViPrice += parseFloat(this.$product.product.ssm_fees);
                if(this.$store.getters.activeWebsite && this.$store.getters.activeWebsite.user) totalViPrice=totalViPrice*this.$store.getters.activeWebsite.user.production_margin;
                const formatter = new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
                if(this.$product.product.is_customizable && this.$product.product.is_customizable == 1) totalViPrice+= parseFloat(this.$product.product.first_margin_fee);
                const finalPrice = (parseFloat(formatter.format(this.currProductMargin))+parseFloat(formatter.format(totalViPrice))).toFixed(2);
                this.currProductPrice = finalPrice;
            },
            getMinimumProductPrice(){
                let minPrice;
                let variantPrice = this.$product.product.smake.price;
                let sizeOfVariants = this.$product.product.variants.length;
                let sizeOfCreatedVariants = this.$product.product.smake.data.variants.length;
                if(this.$product.product.variants && sizeOfVariants > 0){
                    for(let i=0; i<sizeOfCreatedVariants;i++){
                        if((this.$product.product.smake.data.variants[i].attributes[1].value == 'XS' || this.$product.product.smake.data.variants[i].attributes[1].value == 'S') && this.$product.product.smake.data.variants[i].total){
                            for(let j=0;j<sizeOfVariants;j++){
                                if(this.$product.product.variants[j].attributes[0].value == this.$product.product.smake.data.variants[i].attributes[0].value){
                                    variantPrice = this.$product.product.smake.data.variants[i].total;
                                    i = sizeOfCreatedVariants;
                                    j = sizeOfVariants;
                                }
                            }
                        }
                    }
                } else {
                    let sizeOfVariants = this.$product.product.smake.data.variants.length;
                    for(let i=0; i<sizeOfVariants;i++){
                        if((this.$product.product.smake.data.variants[i].attributes[1].value == 'XS' || this.$product.product.smake.data.variants[i].attributes[1].value == 'S') && this.$product.product.smake.data.variants[i].total){
                            variantPrice = this.$product.product.smake.data.variants[i].total;
                            i = sizeOfVariants;
                        }
                    }
                }

                if(this.$product.product.is_customizable && this.$product.product.is_customizable == 1){
                    minPrice = parseFloat(variantPrice) + parseFloat(this.$product.product.first_custom_fee);
                } else {
                    if(this.$product.totalPrintAreas == 1  || !this.$product.product.smake.print_price_second){
                        minPrice = parseFloat(variantPrice) + parseFloat(this.$product.product.smake.print_price * this.$product.totalPrintAreas);
                    } else {
                        minPrice = parseFloat(variantPrice) + parseFloat(this.$product.product.smake.print_price  + this.$product.product.smake.print_price_second);
                    }
                }

                if(this.$product.product.ssm_fees) minPrice+=parseFloat(this.$product.product.ssm_fees);
                if(this.$store.getters.activeWebsite && this.$store.getters.activeWebsite.user) minPrice=minPrice*this.$store.getters.activeWebsite.user.production_margin;
                return minPrice.toFixed(2);
            },
            updateFee(){
                let data = {
                    'id':  this.$product.product.id,
                    'ssm_fees': parseFloat(this.$product.product.ssm_fees)
                }
                updateCustomFee(data).then(res=>{
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Custom fee updated successfully', type:'success'});
                })
            }
        },
    }
</script>
